import type React from 'react'
import { cn } from '@/lib/utils'

interface CenterContainerProps extends React.HTMLAttributes<HTMLDivElement> {
  children?: React.ReactNode
}

/** Full-height centred layout with one raised panel — status and error pages. */
export default function CenterContainer({ children, className, ...props }: CenterContainerProps) {
  return (
    <main className="flex min-h-screen items-center justify-center px-4 py-12">
      <div
        className={cn(
          'w-full max-w-[640px] rounded-ds-md border border-line bg-surface-raised/85 px-6 py-10 text-center text-ink-body sm:px-12',
          className
        )}
        {...props}
      >
        {children}
      </div>
    </main>
  )
}
